<app-modal
  [isOpen]="isOpen()"
  title="Esqueci minha Senha"
  (closed)="onClose()"
>
  @if (successSent()) {
    <div class="success-content">
      <div class="success-icon">
        <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <p class="success-message">E-mail enviado com sucesso!</p>
    </div>
  } @else {
    <form (ngSubmit)="onSubmit()" class="forgot-form">
      @if (errorMessage()) {
        <p class="error-message" role="alert">{{ errorMessage() }}</p>
      }
      <p class="forgot-instruction">
        Informe no campo abaixo o e-mail cadastrado para receber o link de redefinição de senha.
      </p>
      <label class="field-label">E-mail</label>
      <input
        type="email"
        class="field-input"
        placeholder="(ex.: email@givo.com)"
        [maxlength]="limits.email"
        [ngModel]="email()"
        (ngModelChange)="email.set($event)"
        name="email"
        autocomplete="email"
      />
      <button type="submit" class="btn-submit" [disabled]="loading()">
        {{ loading() ? 'Enviando...' : 'Enviar Link de Redefinição' }}
      </button>
    </form>
  }
</app-modal>
